import React, { useEffect, useState } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";
import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import { createLowlight } from 'lowlight';

import Select from "react-select";
import { supabase } from "../lib/supabaseClient";
const lowlight = createLowlight();
  

export default function EditLearningPage() {
    const [outlineOptions, setOutlineOptions] = useState([]);
  const [selectedOutline, setSelectedOutline] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const editor = useEditor({
    extensions: [
      StarterKit,
      Image,
      CodeBlockLowlight.configure({ lowlight }),
    ],
    content: "<p>Select an outline and start editing...</p>",
  });

  // Fetch dropdown options (same as InsertLearningQA)
  useEffect(() => {
    const fetchOutlines = async () => {
      const { data, error } = await supabase
        .from("topics")
        .select(`id, name, parent:parent_id ( module_code )`)
        .eq("level", 3)
        .order("name");

      if (!error && data) {
        const formatted = data.map((o) => ({
          value: o.id,
          label: `${o.parent?.module_code || "❓"} - ${o.name}`,
        }));
        setOutlineOptions(formatted);
      }
    };

    fetchOutlines();
  }, []);

  // Load content when outline is selected
  useEffect(() => {
    const fetchContent = async () => {
      if (!selectedOutline || !editor) return;

      const { data, error } = await supabase
        .from("learning_rich")
        .select("content_html")
        .eq("outline_id", selectedOutline.value)
        .single();

      if (data?.content_html) {
        editor.commands.setContent(data.content_html);
      } else {
        editor.commands.setContent("<p>No content yet. Start writing!</p>");
      }
    };

    fetchContent();
  }, [selectedOutline, editor]);

  // Save content
  const handleSave = async () => {
    if (!selectedOutline || !editor) {
      setStatus("❌ Please select an outline and enter some content.");
      return;
    }

    setLoading(true);
    const content_html = editor.getHTML();
    const content_json = editor.getJSON();

    const { error } = await supabase.from("learning_rich").upsert({
      outline_id: selectedOutline.value,
      content_html,
      content_json,
    });

    setLoading(false);
    setStatus(error ? "❌ Failed to save content." : "✅ Content saved!");
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4 text-indigo-700">📘 Edit Learning Page (Visual)</h2>

      <div className="mb-4">
        <label className="font-semibold mb-2 block">Select Outline:</label>
        <Select
          options={outlineOptions}
          value={selectedOutline}
          onChange={setSelectedOutline}
          placeholder="Choose outline..."
        />
      </div>

      <EditorContent editor={editor} className="border p-2 bg-white min-h-[300px] mb-4 rounded" />

      <button
        onClick={handleSave}
        disabled={loading}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        {loading ? "Saving..." : "💾 Save"}
      </button>

      {status && <div className="mt-2 text-indigo-700 font-medium">{status}</div>}
    </div>
  );
}
